import { memo, useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { Tabs, Typography } from 'antd';

import { VERTICAL_URL } from 'settings';

import Product from './Product';

type ISubscriptionTabs = 'subscriptions' | 'products';

const SUBSCRIPTIONS_URL = `${VERTICAL_URL}/subscriptions/me`;

const Subscriptions = memo(() => {
  const { tabName } = useParams<{ tabName: ISubscriptionTabs }>();

  const [tab, setTab] = useState<ISubscriptionTabs>(() => {
    return 'products';
  });

  const redirectToSubscriptions = useCallback(() => {
    window.location.replace(SUBSCRIPTIONS_URL);
  }, []);

  useEffect(() => {
    if (tabName === 'subscriptions') {
      redirectToSubscriptions();
    }
  }, [redirectToSubscriptions, tabName]);

  const handleChange = useCallback(
    (tab: ISubscriptionTabs) => {
      if (tab === 'subscriptions') {
        redirectToSubscriptions();
        return;
      }

      setTab(tab);
    },
    [redirectToSubscriptions]
  );

  if (tabName === 'subscriptions') {
    return null;
  }

  return (
    <div id='my-subscriptions' className='flex w-full flex-col gap-6'>
      <div>
        <Typography.Title level={3} className='m-0'>
          Minhas Compras
        </Typography.Title>
        <Typography.Text type='secondary'>
          Gerencie e acesse os produtos que você adquiriu dentro da plataforma Eduzz.
        </Typography.Text>
      </div>

      <Tabs
        activeKey={tab}
        onChange={handleChange}
        items={[
          { key: 'products', label: 'Produtos', children: <Product /> },
          { key: 'subscriptions', label: 'Assinaturas' }
        ]}
      />
    </div>
  );
});

export default Subscriptions;
